<img
  width="164"
  height="29"
  alt="Evernorth Health Services"
  [src]="logoPath | cdnPrefix"
/>
